import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { useLang } from "@/lib/LangContext";

export default function FaqSection() {
  const { faq: FAQ, lang } = useLang();
  const [open, setOpen] = useState(0);

  return (
    <section
      data-testid="faq-section"
      className="border-t border-border bg-background"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <div className="md:sticky md:top-32">
              <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-6">
                [ 05 · {lang === "fr" ? "Débriefing" : "Debrief"} ]
              </div>
              <h2 className="font-serif font-light text-4xl md:text-6xl tracking-tighter leading-[1]">
                {lang === "fr" ? (
                  <>Questions <br /> <i className="text-primary">fréquentes.</i></>
                ) : (
                  <>Common <br /> <i className="text-primary">Questions.</i></>
                )}
              </h2>
            </div>
          </div>

          <div className="md:col-span-8 border-t border-border">
            {FAQ.map((f, i) => (
              <div
                key={i}
                className="border-b border-border"
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full flex items-start justify-between gap-8 py-8 text-left group"
                >
                  <div className="flex items-start gap-6">
                    <span className="font-mono text-[10px] tracking-[0.25em] text-muted-foreground pt-2">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-serif text-2xl md:text-3xl tracking-tight leading-tight group-hover:text-primary transition-colors">
                      {f.q}
                    </span>
                  </div>
                  <div className="pt-3 flex-shrink-0">
                    {open === i ? (
                      <Minus size={20} strokeWidth={1.2} className="text-primary" />
                    ) : (
                      <Plus size={20} strokeWidth={1.2} />
                    )}
                  </div>
                </button>
                <AnimatePresence>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.76, 0, 0.24, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pl-0 md:pl-12 pb-10 pr-12 text-foreground/75 leading-relaxed max-w-2xl">
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
